/**
 * Include your custom JavaScript here.   
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(evt) {
      resolve(evt.target.result);
    };
    reader.readAsDataURL(file);
  })
};

 class Lenses {
  constructor(ProductHandle, ProductVariantId) {
    this.ProductHandle = ProductHandle;
    this.ProductVariantId = ProductVariantId;

    this.lensData = window.lensData;
    this.productVariant = null;
    this.prescriptionTableData = {
      sph: {
        name: "Sphere (SPH)",
        values: ["None", "-10.00","-9.75","-9.50","-9.25","-9.00","-8.75","-8.50","-8.25","-8.00","-7.75","-7.50","-7.25","-7.00","-6.75","-6.50","-6.25","-6.00","-5.75","-5.50","-5.25","-5.00","-4.75","-4.50","-4.25","-4.00","-3.75","-3.50","-3.25","-3.00","-2.75","-2.50","-2.25","-2.00","-1.75","-1.50","-1.25","-1.00","-0.75","-0.50","-0.25","0.00","+0.25","+0.50","+0.75","+1.00","+1.25","+1.50","+1.75","+2.00","+2.25","+2.50","+2.75","+3.00","+3.25","+3.50","+3.75","+4.00","+4.25","+4.50","+4.75","+5.00","+5.25","+5.50","+5.75","+6.00"]
      },
      cyl: {
        name: "Cylinder (CYL)",
        values: ["None", "-2.00","-1.75","-1.50","-1.25","-1.00","-0.75","-0.50","-0.25","0.00","+0.25","+0.50","+0.75","+1.00","+1.25","+1.50","+1.75","+2.00"]
      },
      axis: {
        name: "Axis",
        values: ["None", "0","5","10","15","20","25","30","35","40","45","50","55","60","65","70","75","80","85","90","95","100","105","110","115","120","125","130","135","140","145","150","155","160","165","170","175","180"]
      },
      add: {
        name: "ADD",
        values:["None","+0.50","+0.75","+1.00","+1.25","+1.50","+1.75","+2.00","+2.25","+2.50","+2.75","+3.00","+3.25","+3.50","+3.75","+4.00"]
      },
      pd: {
        name: "<span>PD</span><span class='d-none d-md-block'>(Pupillary Distance)</span>",
        values: ["Not Sure","52","53","54","55","56","57","58","59","60","61","62","63","64","65","66","67","68","69","70","71","72","73","74","75"]
      }
    };

    this.history = [];

    this.SelectorLenses = ".shopify-section-lenses";
    this.SelectorTitle = "[data-lenses-select-title]";
    this.SelectorSteps = "[data-lenses-select-steps]";
    this.SelectorContent = "[data-lenses-select-content]";
    this.SelectorPrev = "[data-lenses-select-prev]";
    this.SelectorClear = "[data-lenses-select-close]";
    this.SelectorAddToCart = "[data-lenses-add-to-cart]";

    this.$dialog = null;
    this.$lenses = null;
    this.$title = null;
    this.$steps = null;

    this.prescription = {
      id: null,
      type: null,
      value: null
    }

    this._init();
  }
  static getProductLensesHtml (ProductHandle, ProductVariantId) {
    if (!ProductHandle) return null;
    let url = ProductHandle + "?sections=lenses";
    if (ProductVariantId) url += "&variant=" + ProductVariantId;
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url,
        success: function (response) {
          resolve(response.lenses);
        }
      });
    });
  }
  static getMoney(price) {
    price = (price / 100).toFixed(2);
    return theme.moneyFormat.replace("{{amount}}", price);
  }
  static AjaxAddToCartByFormData(formData) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'post',
        data: formData,
        dataType: 'json',
        url: '/cart/add',
        processData: false,  // 告诉jQuery不要去处理发送的数据
        contentType: false,   // 告诉jQuery不要去设置Content-Type请求头
        success: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }
  static AjaxAddToCart(items) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: "/cart/add",
        data: {
          items
        },
        dataType: "json",
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          reject(error);
        }
      });
    })
  }
  async _init () {
    this.created();
    this.mounted();
  }
  async created() {
    const SelectorHeader = "#shopify-section-header"
    const top = parseInt($(SelectorHeader).offset().top - $(window).scrollTop()) + parseInt($(SelectorHeader).height());
    let dialogHtml = /*html*/`
      <div id="dialog-${this.ProductHandle}" class="dialog" style="top: ${top}px;height: calc(100% - ${top}px); z-index: 9;">
        <div class="dialog-body">
          ${theme.icons.loading}
        </div>
      </div>
    `;
    $('html').addClass('isFixed');
    $('body').append(dialogHtml);
    this.$dialog = $(`#dialog-${this.ProductHandle}`);
    this.$dialog.fadeIn();
    const lensesHtml = await Lenses.getProductLensesHtml(this.ProductHandle, this.ProductVariantId);
    this.$dialog.find('.dialog-body').html(lensesHtml);

    this.productVariant = JSON.parse(this.$dialog.find(".product-variant-json").html());

    this.$lenses = this.$dialog.find(this.SelectorLenses);
    this.$title = this.$lenses.find(this.SelectorTitle);
    this.$steps = this.$lenses.find(this.SelectorSteps);
    this.$content = this.$lenses.find(this.SelectorContent);

    this.creatSteps(this.lensData.steps);
    this.toSelect(this.lensData.select);
    this.$lenses.fadeIn();
  }
  creatSteps(steps) {
    let html = '';
    for (let i = 0; i < steps; i++) {
      if (i > 0) html += /*html*/`<li class="step-line" data-step="${i}"></li>`
      html += /*html*/`<li class="step-node" data-step="${i}"></li>`;
    }
    this.$steps.html(html);
  }
  updateTitle(title) {
    this.$lenses.find("[data-lenses-select-title]").text(title);
  }
  updateSteps(step) {
    this.$steps.find('li').each(function (index, element) {
      const _step = $(this).data('step');
      if (_step < step) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });
  }
  
  toSelect(select) {
    const _this = this;
    this.history.push({
      type: "select",
      select
    });
    this.updateTitle(select.title);
    this.updateSteps(select.step);
    this.$content.html("").hide();
    select.options.forEach((option, index) => {
      const html = /*html*/`
        <div class="lenses-select-option">
          <div class="icon-wrap">
            <img src="${option.icon}">
          </div>
          <div class="info-wrap">
            <div class="info-head">
              <div class="info-name">${option.name}</div>
              <div class="info-price">${option.price || ''}</div>
            </div>
            <div class="info-desc">${option.description}</div>
          </div>
        </div>
      `;
      _this.$content.append(html);
      _this.$content.find(".lenses-select-option").eq(index).click(function(){
        // lens > prescription > select
        if (option.lens) {
          if (option.prescription) {
            _this.toPrescription(select, option);
          } else {
            _this.toDetails(option);
          }
        } else {
          _this.toSelect(option.select);
        }
      });
      _this.$content.fadeIn();
    });
  }
  
  toDetails(option) {
    const _this = this;
    this.history.push({
      type: "details",
      option
    });
    this.updateTitle(this.lensData.details.name);
    this.updateSteps(this.lensData.steps);
    this.$content.html("").hide();
    let html = _this._getDetailsItemHtml("Details", this.productVariant.name, Lenses.getMoney(this.productVariant.price));
    if (this.prescription.id) {
      html += _this._getPrescriptionInfoHtml(this.prescription.type, this.prescription.value);
    }
    option.lens.properties.forEach(item => {
      html += _this._getDetailsItemHtml(item.name, item.value, item.price);
    });
    html = /*html*/`<div class="lenses-details-body">${html}</div>`;
    html += /*html*/`
      <div class="lenses-details-footer">
        <div class="lenses-details-footer-subtotal">
          <div class="lenses-details-footer-subtotal-name">Subtotal</div>
          <div class="lenses-details-footer-subtotal-price">${Lenses.getMoney(this.productVariant.price + option.lens.price)}</div>
        </div>
        <div class="lenses-details-footer-add-to-cart productForm-buttons--alt">
          <button type="button"
            class="lenses-btn lenses-btn--add-to-cart Button Button--primary"
            data-lenses-add-to-cart>${theme.icons.loading} Add To Cart</button>
        </div>
      </div>
    `;
    _this.$content.append(html);
    _this.$content.find(_this.SelectorAddToCart).click(async function (e) { 
      e.preventDefault();
      try {
        $(this).prop("disabled", true);
        await _this._addToCart(option);
      } catch (error) {
        console.error(error);
      }
      $(this).prop("disabled", false);
    });
    _this.$content.fadeIn();
  }
  _getPrescriptionInfoHtml(type, value) {
    if (!type || !value) return '';
    let html = '';
    switch (type) {
      case 'file':
        html = value.name;
        break;
      case 'table':
        const table = {};
        const arr = value.split(',');
        arr.forEach(item => {
          item = item.split(':');
          const name = $.trim(item[0]);
          const value = $.trim(item[1]);
          table[name] = value;
        });
        html = /*html*/`
            <div><div></div><div>OD</div><div>OS</div></div>
            <div><div>SPH</div><div>${table.OD_SPH}</div><div>${table.OS_SPH}</div></div>
            <div><div>CYL</div><div>${table.OD_CYL}</div><div>${table.OS_CYL}</div></div>
            <div><div>Axis</div><div>${table.OD_Axis}</div><div>${table.OS_Axis}</div></div>
        `;
        if (table.OD_ADD) html += /*html*/`<div><div>ADD</div><div>${table.OD_ADD}</div><div>${table.OS_ADD}</div></div>`;
        html += /*html*/`<div><div>PD</div><div>${table.PD}</div></div>`;
        html = `<div class="lenses-prescription-table-info">${html}</div>`
        break;
      default:
        html = value;
        break;
    }
    return /*html*/`
    <div class="lenses-details-item">
      <div class="lenses-details-item-name">Your prescription</div>
      <div class="lenses-details-item-value">
        ${html}
      </div>
    </div>`;
  }

  toPrescription(select, option) {
    const _this = this;
    this.history.push({
      type: "prescription",
      select,
      option
    });
    const pid = option.prescription;
    const prescriptionTitle = (() => {
      this.lensData.prescriptions.forEach(_p => {
        if (_p.id == pid) return _p.name;
      });
    })()
    this.updateTitle(prescriptionTitle);
    this.updateSteps(select.step);
    let html = /*html*/`<div class="lenses-prescription-content">${this._getPrescriptionHtml(pid)}</div>`;
    this.$content.html("").hide().append(html);
    // 事件
    this.$content.find("[data-lenses-prescription-click]").click(function (e) { 
      e.preventDefault();
      const t = $(this).data("lenses-prescription-click");
      if (t === "enter") {
        _this.prescription.id = pid;
        _this.prescription.type = "text";
        _this.prescription.value = "Send it later";
        _this.toDetails(option);
      } else {
        _this.$dialog.find(_this.SelectorPrev).attr("data-lenses-prescription-row-content", t)
        _this.$content.find(".lenses-prescription-row").hide();
        _this.$content.find(`.lenses-prescription-row-content-${t}`).fadeIn();
      }
    });

    // Cyl and Axis
    this.$content.find("[name=OD_CYL], [name=OS_CYL]").change(function (e) { 
      const name = $(this).attr("name");
      const value = $(this).val();
      let $axis = _this.$content.find('[name=OD_Axis]');
      if (name == "OS_CYL") $axis = _this.$content.find('[name=OS_Axis]');
      const isDisabled = $axis.prop("disabled");
      if (value === "None") {
        if (!isDisabled) {
          $axis.val("None").prop("disabled", true);
        }
      } else {
        if (isDisabled) {
          $axis.prop("disabled", false);
        }
      }
    });
    // update
    this.$content.find("[data-prescription-file]").change(async function(){
      const file = $(this)[0].files[0];
      if (file) {
        _this.$content.find("[data-lenses-file-name]").text(file.name);
        const imgSrc = await fileToBase64(file);
        $(this).parent().css('background-image',`url(${imgSrc})`);
      } else {
        _this.$content.find("[data-lenses-file-name]").text('');
      }
    })
    // Confirm
    5
    this.$content.find("[data-lenses-prescription-confirm]").click(function(){
      let isOk = false;
      const t = $(this).data("lenses-prescription-confirm");
      if (t === "file") {
        const file = _this.$content.find("[data-prescription-file]")[0].files[0];
        if (file) {
          _this.prescription.id = pid;
          _this.prescription.type = "file";
          _this.prescription.value = file;
          isOk = true;
        } else {
          return false;
        }
      } else if (t === "table") {
        let table = "";
        _this.$content.find("[data-prescription-table] select").each(function (index, element) {
          const name = $(this).attr("name");
          const value = $(this).val();
          if (index !== 0) table += ', ';
          table += name + ': ' + value;
        });
        _this.prescription.id = pid;
        _this.prescription.type = "table";
        _this.prescription.value = table;
        isOk = true;
      }
      if (isOk) {
        _this.toDetails(option);
      }
    });

    _this.$content.fadeIn();
  }
  _getOptionHtmlByValues(values) {
    let html = '';
    values.forEach(value => {
      html += /*html*/`<option value="${value}">${value}</option>`
    });
    return html;
  }
  _getPrescriptionHtml(pid) {
    let fileHtml = /*html*/`
      <div class="lenses-prescription-row">
        <div class="lenses-prescription-row-body">
          <div class="lenses-prescription-row-icon">
            ${theme.icons.upload}
          </div>
          <div class="lenses-prescription-row-text">
            <span class="text-color-active font-weight-bold">Upload a photo </span>
            <span class="font-weight-bold">of your prescription, we can help!</span>
            This is the quickest option!
          </div>
        </div>
        <div class="lenses-prescription-row-button-wrap">
          <button type="button" class="lenses-prescription-row-button" data-lenses-prescription-click="file">UPLOAD NOW</button>
        </div>
      </div>
    `;
    let afterCheckoutHtml = /*html*/`
      <div class="lenses-prescription-row">
        <div class="lenses-prescription-row-body">
          <div class="lenses-prescription-row-icon">
            ${theme.icons.email}
          </div>
          <div class="lenses-prescription-row-text">
            <span class="text-color-active font-weight-bold">Send it to us later. </span>
            We’ll email you to get your prescription after checkout.
          </div>
        </div>
        <div class="lenses-prescription-row-button-wrap">
          <button type="button" class="lenses-prescription-row-button" data-lenses-prescription-click="enter">ENTER NOW</button>
        </div>
      </div>
    `;
    let tableHtml = /*html*/`
      <div class="lenses-prescription-row">
        <div class="lenses-prescription-row-body">
          <div class="lenses-prescription-row-icon">
            ${theme.icons.email}
          </div>
          <div class="lenses-prescription-row-text">
            <span class="text-color-active font-weight-bold">Enter prescription manually. </span><br>
            If you clearly understand your prescription.
          </div>
        </div>
        <div class="lenses-prescription-row-button-wrap">
          <button type="button" class="lenses-prescription-row-button" data-lenses-prescription-click="table">CONTINUE</button>
        </div>
      </div>
    `;

    let fileContentHtml = /*html*/`
      <div class="lenses-prescription-row-content lenses-prescription-row-content-file">
        <div class="lenses-prescription-row-content-text">
          <span class="text-color-active font-weight-bold">Upload a photo </span>
          <span class="font-weight-bold">of your prescription, we can help!</span>
          This is the quickest option!
        </div>
        <div class="lenses-prescription-row-content-body">
          <div class="lenses-prescription-file-input-wrap">
            <label class="lenses-prescription-file-label">
              <input class="Button lenses-prescription-file-input" type="file" data-prescription-file hidden>
              <span class="lenses-prescription-file-text">Upload my prescription</span>
            </label>
          </div>
        </div>
        <div class="lenses-prescription-row-content-footer">
          <div>
            <a class="lenses-prescription-link" href="#">${theme.icons.help}Contact Customer Support</a>
          </div>
          <div>
            <button type="button" class="lenses-prescription-confirm-button" data-lenses-prescription-confirm="file">CONFIRM</button>
          </div>
        </div>
      </div>
    `;
    let tableContentHtml = /*html*/`
      <div class="lenses-prescription-row-content lenses-prescription-row-content-table">
        <div class="row row-cols-1 row-cols-md-5 mt-4 lenses-prescription-table" data-prescription-table>
          <!-- OD/OS -->
          <div class="col px-2 col-ods">
            <div class="row">
              <div class="col-4 col-md-12 zq-name mt-2"></div>
              <div class="col-4 col-md-12 zq-ob mt-2"><span>OD</span><span>(Right eye)</span></div>
              <div class="col-4 col-md-12 zq-os mt-2"><span>OS</span><span>(Left eye)</span></div>
            </div>
          </div>
          <!-- SPH -->
          <div class="col px-2 col-sph">
            <div class="row">
              <div class="col-4 col-md-12 zq-name mt-2">${this.prescriptionTableData.sph.name}</div>
              <div class="col-4 col-md-12 mt-2">
                <select name="OD_SPH" class=" border-bottom zq-select">
                  ${this._getOptionHtmlByValues(this.prescriptionTableData.sph.values)}
                </select>
              </div>
              <div class="col-4 col-md-12 mt-2">
                <select name="OS_SPH" class=" border-bottom zq-select">
                  ${this._getOptionHtmlByValues(this.prescriptionTableData.sph.values)}
                </select>
              </div>
            </div>
          </div>
          <!-- CYL -->
          <div class="col px-2 col-cyl">
            <div class="row">
              <div class="col-4 col-md-12 zq-name mt-2">${this.prescriptionTableData.cyl.name}</div>
              <div class="col-4 col-md-12 mt-2">
                <select name="OD_CYL" class=" border-bottom zq-select">
                  ${this._getOptionHtmlByValues(this.prescriptionTableData.cyl.values)}
                </select>
              </div>
              <div class="col-4 col-md-12 mt-2">
                <select name="OS_CYL" class=" border-bottom zq-select">
                  ${this._getOptionHtmlByValues(this.prescriptionTableData.cyl.values)}
                </select>
              </div>
            </div>
          </div>
          <!-- Axis -->
          <div class="col px-2 col-axis">
            <div class="row">
              <div class="col-4 col-md-12 zq-name mt-2">${this.prescriptionTableData.axis.name}</div>
              <div class="col-4 col-md-12 mt-2">
                <select name="OD_Axis" class=" border-bottom zq-select" disabled>
                  ${this._getOptionHtmlByValues(this.prescriptionTableData.axis.values)}
                </select>
              </div>
              <div class="col-4 col-md-12 mt-2">
                <select name="OS_Axis" class=" border-bottom zq-select" disabled>
                  ${this._getOptionHtmlByValues(this.prescriptionTableData.axis.values)}
                </select>
              </div>
            </div>
          </div>
          ${ pid == 1 ? /*html*/`
            <!-- ADD -->
            <div class="col px-2 col-add">
            <div class="row">
              <div class="col-4 col-md-12 zq-name mt-2">${this.prescriptionTableData.add.name}</div>
              <div class="col-4 col-md-12 mt-2">
                <select name="OD_ADD" class=" border-bottom zq-select">
                  ${this._getOptionHtmlByValues(this.prescriptionTableData.add.values)}
                </select>
              </div>
              <div class="col-4 col-md-12 mt-2">
                <select name="OS_ADD" class=" border-bottom zq-select">
                  ${this._getOptionHtmlByValues(this.prescriptionTableData.add.values)}
                </select>
              </div>
            </div>
          </div>
          ` : "" }

          <!-- PD -->
          <div class="col-12 col-md-12 px-2 col-pd">
            <div class="row row-cols-3 row-cols-md-5 mx-md--2">
              <div class="col px-0 mt-2 zq-pd">${this.prescriptionTableData.pd.name}</div>
              <div class="col px-md-2 mt-2">
              <select name="PD" class=" border-bottom zq-select">
                ${this._getOptionHtmlByValues(this.prescriptionTableData.pd.values)}
              </select>
            </div>
            </div>
          </div>

        </div>
        <div class="lenses-prescription-row-content-footer">
          <div>
            <a class="lenses-prescription-link" href="#">${theme.icons.help}Contact Customer Support</a>
          </div>
          <div>
            <button type="button" class="lenses-prescription-confirm-button"  data-lenses-prescription-confirm="table">CONFIRM</button>
          </div>
        </div>
      </div>
    `;

    let confirmHtml = /*html*/``;
    return /*html*/`
      ${fileHtml}
      ${afterCheckoutHtml}
      ${tableHtml}
      ${fileContentHtml}
      ${tableContentHtml}
      ${confirmHtml}
    `;
  }
  _getPrescriptionHtml1(pid) {
    let tableHtml = /*html*/`
      <div class="row row-cols-1 row-cols-md-5 mt-4 lenses-prescription-table" data-prescription-table>
        <!-- OD/OS -->
        <div class="col px-2 col-ods">
          <div class="row">
            <div class="col-4 col-md-12 zq-name mt-2"></div>
            <div class="col-4 col-md-12 zq-ob mt-2"><span>OD</span><span>(Right eye)</span></div>
            <div class="col-4 col-md-12 zq-os mt-2"><span>OS</span><span>(Left eye)</span></div>
          </div>
        </div>
        <!-- SPH -->
        <div class="col px-2 col-sph">
          <div class="row">
            <div class="col-4 col-md-12 zq-name mt-2">${this.prescriptionTableData.sph.name}</div>
            <div class="col-4 col-md-12 mt-2">
              <select name="OD_SPH" class=" border-bottom zq-select">
                ${this._getOptionHtmlByValues(this.prescriptionTableData.sph.values)}
              </select>
            </div>
            <div class="col-4 col-md-12 mt-2">
              <select name="OS_SPH" class=" border-bottom zq-select">
                ${this._getOptionHtmlByValues(this.prescriptionTableData.sph.values)}
              </select>
            </div>
          </div>
        </div>
        <!-- CYL -->
        <div class="col px-2 col-cyl">
          <div class="row">
            <div class="col-4 col-md-12 zq-name mt-2">${this.prescriptionTableData.cyl.name}</div>
            <div class="col-4 col-md-12 mt-2">
              <select name="OD_CYL" class=" border-bottom zq-select">
                ${this._getOptionHtmlByValues(this.prescriptionTableData.cyl.values)}
              </select>
            </div>
            <div class="col-4 col-md-12 mt-2">
              <select name="OS_CYL" class=" border-bottom zq-select">
                ${this._getOptionHtmlByValues(this.prescriptionTableData.cyl.values)}
              </select>
            </div>
          </div>
        </div>
        <!-- Axis -->
        <div class="col px-2 col-axis">
          <div class="row">
            <div class="col-4 col-md-12 zq-name mt-2">${this.prescriptionTableData.axis.name}</div>
            <div class="col-4 col-md-12 mt-2">
              <select name="OD_Axis" class=" border-bottom zq-select" disabled>
                ${this._getOptionHtmlByValues(this.prescriptionTableData.axis.values)}
              </select>
            </div>
            <div class="col-4 col-md-12 mt-2">
              <select name="OS_Axis" class=" border-bottom zq-select" disabled>
                ${this._getOptionHtmlByValues(this.prescriptionTableData.axis.values)}
              </select>
            </div>
          </div>
        </div>
        ${ pid == 1 ? /*html*/`
          <!-- ADD -->
          <div class="col px-2 col-add">
          <div class="row">
            <div class="col-4 col-md-12 zq-name mt-2">${this.prescriptionTableData.add.name}</div>
            <div class="col-4 col-md-12 mt-2">
              <select name="OD_ADD" class=" border-bottom zq-select">
                ${this._getOptionHtmlByValues(this.prescriptionTableData.add.values)}
              </select>
            </div>
            <div class="col-4 col-md-12 mt-2">
              <select name="OS_ADD" class=" border-bottom zq-select">
                ${this._getOptionHtmlByValues(this.prescriptionTableData.add.values)}
              </select>
            </div>
          </div>
        </div>
        ` : "" }

        <!-- PD -->
        <div class="col-12 col-md-12 px-2 col-pd">
          <div class="row row-cols-3 row-cols-md-5 mx-md--2">
            <div class="col px-0 mt-2 zq-pd">${this.prescriptionTableData.pd.name}</div>
            <div class="col px-md-2 mt-2">
            <select name="PD" class=" border-bottom zq-select">
              ${this._getOptionHtmlByValues(this.prescriptionTableData.pd.values)}
            </select>
          </div>
          </div>
        </div>

      </div>
    `;
    let fileHtml = /*html*/`
      <div class="row text-left border-top mt-4 pt-4 lenses-prescription-file">
        <div class="col-12 d-flex " style="align-items: center;">
          <label class="zq-upload-btn zq-btn">Upload my prescription
            <input class="Button" type="file" data-prescription-file hidden>
          </label>
          <p class="file-name" data-lenses-file-name></p>
        </div>
        <div class="col-12 mt-2" style="font-size: .8rem; opacity: .8;">I have a prescription sheet from my doctor but I don’t understand it.</div>
      </div>
    `;
    let afterCheckoutHtml = /*html*/`
      <div class="row text-left border-top mt-4 pt-4 lenses-prescription-after-checkout">
        <div class="col-12">
          <label for="lenses-prescription-after-checkout">Send it later</label>
          <input type="checkbox" id="lenses-prescription-after-checkout" data-prescription-after-checkout hidden/>
          <label for="lenses-prescription-after-checkout" class="checkbox-icon">
            <svg class="icon-svg icon-svg-gou" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2202" width="200" height="200"><path d="M870.4 332.8l-89.6-89.6L416 601.6 243.2 435.2l-89.6 89.6 262.4 256z" p-id="2203"></path></svg>
          </label>
        </div>
        <div class="col-12">
          <label style="font-size: .8rem; opacity: .8;">As soon as you have it, send it to service@inmix.com with your order number.</label>
        </div>
      </div>
    `;
    let confirmHtml = /*html*/`
      <div class="row">
        <div class="col-12">
          <button type="button" data-lenses-prescription-confirm class="lenses-btn zq-btn">Confirm</button>
        </div>
      </div>
    `;
    return /*html*/`
      ${fileHtml}
      ${afterCheckoutHtml}
      ${tableHtml}
      ${confirmHtml}
    `;
  }

  _getDetailsItemHtml(name, value, price) {
    let html = "";
    if (name) {
      html += /*html*/`<div class="lenses-details-item-name">${name}</div>`;
    }
    html += /*html*/`
      <div class="lenses-details-item-vp">
        <div class="lenses-details-item-value">
          ${value}
        </div>
        ${price ? /*html*/`<div class="lenses-details-item-price">${price}</div>` : ''}
      </div>
    `;
    return /*html*/`<div class="lenses-details-item">${html}</div>`;
  }
  async _addToCart(option) {
    const time = new Date().getTime();
    const frameProperties = {
      "_type": 'lens',
      "_lens-price": option.lens.price,
      "_time": time
    };
    if (this.prescription.id) {
      frameProperties["_prescription"] = this.prescription.id,
      frameProperties["_prescription_type"] = this.prescription.type,
      frameProperties["prescription"] = this.prescription.value
    }
    option.lens.properties.forEach(p => {
      frameProperties[p.name] = p.value;
      if (p.price) frameProperties[`_${p.name}-price`] = p.price;
    });
    const items = [{
      id: this.productVariant.id,
      quantity: 1,
      properties: frameProperties
    },{
      id: option.lens.id,
      quantity: 1,
      properties: {
        "Frame": this.productVariant.name,
        "_time": time
      }
    }];

    const formDataLenses = new FormData();
    formDataLenses.append('id', items[0].id);
    formDataLenses.append('quantity', items[0].quantity);
    for (const key in items[0].properties) {
      const value = items[0].properties[key];
      formDataLenses.append(`properties[${key}]`, value);
    }
    const formDataFrame = new FormData();
    formDataFrame.append('id', items[1].id);
    formDataFrame.append('quantity', items[1].quantity);
    for (const key in items[1].properties) {
      const value = items[1].properties[key];
      formDataFrame.append(`properties[${key}]`, value);
    }

    // lens
    const resLenses = await Lenses.AjaxAddToCartByFormData(formDataLenses);
    const resFrame = await Lenses.AjaxAddToCartByFormData(formDataFrame);

    this.clear();
    cartSection._rerenderCart().then(function () {
      cartSection.sidebarDrawer.open();
      inmixHtml();
    });

    // window.location.href = routes.cartUrl;
  }

  clear() {
    this.$dialog.fadeOut("normal", () => {
      this.$dialog.remove();
      $("html").removeClass("isFixed");
    })
  }
  prev() {
    let cursor = this.history.length - 2;
    if (cursor < 0) {
      this.clear();
    } else {
      const data = this.history[cursor];
      this.history.splice(cursor, 2);
      if (data.type === "prescription") {
        this.toPrescription(data.select, data.option);
      } else {
        this.toSelect(data.select)
      }
    }
  }

  mounted() {
    this.$dialog.on("click", this.SelectorPrev, () => {
      const lprc = this.$dialog.find(this.SelectorPrev).attr("data-lenses-prescription-row-content");
      if (lprc) {
        this.$dialog.find(this.SelectorPrev).attr("data-lenses-prescription-row-content", "");
        this.$content.find(".lenses-prescription-row-content").hide();
        this.$content.find(".lenses-prescription-row").fadeIn();
      } else {
        this.prev();
      }
    });
    this.$dialog.on("click", this.SelectorClear, () => {
      this.clear()
    })
  }
}

$(document).on('click', '[data-select-lenses]', function () {
  const ProductHandle = $(this).data('product-handle');
  const ProductVariantId = $(this).parents("form").find("select[name=id]").val();
  window.lenses = new Lenses(ProductHandle, ProductVariantId);  
});

/* cart */
const CartApi = {};
CartApi.update = (data) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data,
      dataType: "json",
      success: function (response) {
        resolve(response);
      }
    });
  })
}

const SelectorFormCart = "form.cart-form[action='/cart']";
const SelectorCheckoutSumbit = SelectorFormCart + " [name=checkout]";
const SelectorCartItemClose =  "[data-cart-item-close]";
const SelectorCartTotalPrice = "[data-cart-total-price]";

/**
 * 购物车 item 删除
 */
let _isCartCloseLoading = false;
$(document).on('click', SelectorCartItemClose, async function () {
  if (_isCartCloseLoading) return;
  _isCartCloseLoading = true;
  const $formCart = $(this).parents('form');
  const $item = $(this).parents("[data-cart-item]");
  const time = $item.data('time');
  const key = $item.data('key');
  const updates = [];
  $formCart.find('[data-cart-item]').each(function (index, element) {
    const _time = $(this).data('time');
    const _key = $(this).data('key');
    if (time) {
      if (time == _time) {
        updates.push(0);
      } else {
        updates.push($(this).find("input[name='updates[]']").val());
      }
    } else {
      if (_key == key) {
        updates.push(0);
      } else {
        updates.push($(this).find("input[name='updates[]']").val());
      }
    }
  });
  const res = await CartApi.update({updates});
  const $removeItems = [];
  for (let i = 0; i < updates.length; i++) {
    const v = updates[i];
    if (v == 0) {
      $removeItems.push($formCart.find('[data-cart-item]').eq(i));
    }
  }
  $removeItems.forEach($dom => {
    $dom.fadeOut(500,function() {
      $(this).remove();
      updateCartTotalPrice(res.total_price);
    })
  });
  _isCartCloseLoading = false;
});

/**
 * 更新购物车价格
 */
const updateCartTotalPrice = price => {
  $(SelectorCartTotalPrice).text(Lenses.getMoney(price));
}

/**
 * 购物车数据更正
 */
$(document).ready(async function () {
  let CartData = JSON.parse($("#cartJson").html());
  let isUpdateCart = false;
  let updates = [];
  CartData.items.forEach(item => {
    if (item.properties && item.properties._add_to_cart_time) {
      isUpdateCart = true;
      updates.push(0);
    } else {
      updates.push(item.quantity);
    }
  });
  if (isUpdateCart) {
    await CartApi.update({updates});
    window.location.reload();
  }
  inmixHtml();
});

